import { jwtDecode } from "jwt-decode";

export const getDjId = () => {
  const token = localStorage.getItem("token");

  if (!token) {
    console.error("Token not found");
    return null;
  }

  try {
    const decoded = jwtDecode(token);
    return decoded.id;
  } catch (error) {
    console.error("Invalid token", error);
    return null;
  }
};
